export const contactNumberRegex = /^0\d{9}$/;
export const emailReg = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
export const amountReg = /^[0-9]+(\.[0-9][0-9]?)?$/;
export const plusRegex = /^\+\d+$/;
